import {SelfConfig} from './SelfConfig';
import {TInitModule} from "../../interface"
import {ButtonFunctions} from "@app/modules/SelfConfig/components/ButtonFunctions";

export function init(): TInitModule {
    return {
        component: SelfConfig,
        buttonFunctions: ButtonFunctions
    }
}
